import { required, maxLength } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    canais: { required, maxLength: maxLength(60) },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Nome é obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Nome não pode conter mais de 30 caracteres.')
    return errors
  },
  canaisErrors() {
    const errors = []
    if (!this.$v.form.canais.$dirty) return errors
    !this.$v.form.canais.required && errors.push('O campo string é obrigatório.')
    !this.$v.form.canais.maxLength && errors.push('O campo string deve ter no máximo 60 caracteres.')
    return errors
  },
}
